import { render } from "./10secDraw.vue?vue&type=template&id=03e0c2d4"
import script from "./10secDraw.vue?vue&type=script&lang=js"
export * from "./10secDraw.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__